module.exports = __webpack_public_path__ + "static/media/calendar-check-outline.13410ff4.svg";